<template>
</template>

<script>
import StripePay from '../../FreeCarCheck/StripePay';
export default {
    data: function () {
        return {
            disableOnSubmit: false,
            // Identity Verification (Vin)
            showIdentityVerificationMessage: false,
            identityVerificationMessage: '',
            identityVerificationMessageClass: '',
            // Verify Vin
            showVerifyVinForm: false,
            showVerifyVinButton: !this.vinIsVerified,
            reportVin: this.vin,
            reportVinIsVerified: this.vinIsVerified,
            // Report Image
            reportImage: '',
            reportImageUrl: this.imageUrl,
            customImageSet: this.hasCustomImage,
            // Verify Finance
            showFinanceVerificationForm: false,
            showFinanceVerificationMessage: false,
            financeVerificationMessage: '',
            financeVerificationMessageClass: '',
            financeVerification: {},
            showVerificationUpload: false,
            visibleAgreements: this.agreements,
            agreementIndex: null,
            // WriteOff Investigation
            showWriteOffInvestigationMessage: false,
            writeOffInvestigationMessage: '',
            writeOffInvestigationMessageClass: '',
            writeOffInvestigation: {},
            visibleWriteOffs: this.writeoffs,
            writeOffIndex: null,
            // Stolen Investigation
            showStolenInvestigationMessage: false,
            stolenInvestigationMessage: '',
            stolenInvestigationMessageClass: '',
            stolenInvestigation: {},
            visibleStolenRecords: this.stolenRecords,
            stolenIndex: null,
            // At Risk Investigation
            showAtRiskInvestigationMessage: false,
            atRiskInvestigationMessage: '',
            atRiskInvestigationMessageClass: '',
            atRiskInvestigation: {},
            visibleAtRiskRecords: this.atRiskRecords,
            atRiskIndex: null,
            // Condition Alert Investigation
            showConditionAlertInvestigationMessage: false,
            conditionAlertInvestigationMessage: '',
            conditionAlertInvestigationMessageClass: '',
            conditionAlertInvestigation: {},
            visibleConditionAlertRecords: this.conditionAlerts,
            conditionAlertIndex: null,
            // Add Mileage Reading
            odometerReading: null,
            odometerUnits: 'ml',
            chartType: 'miles',
            visibleMileageChartDataKm: this.mileageChartDataKm,
            visibleMileageChartDataMiles: this.mileageChartDataMiles,
            hasMileageDiscrepancy: this.mileageDiscrepancy,
            // Mileage investigation
            showMileageInvestigationMessage: false,
            mileageInvestigationMessage: '',
            mileageInvestigationMessageClass: '',
            mileageInvestigation: {'content' : ''},
            visibleMileage: this.mileage,
            // Refresh MOT data
            visibleMotData: this.motData,
            visibleMotHistory: this.motHistory,
            showRefreshMotDataMessage: false,
            refreshMotDataMessage: '',
            refreshMotDataMessageClass: '',
            // Retrieve Mileage
            showRetrieveValuationDataMessage: false,
            retrieveValuationDataMessage: '',
            retrieveValuationDataMessageClass: '',
            retrieveValuationDataError: 'no-new-data',
            // Payment
            method: 'stripe',
            selectedPrice: '0',
            product: null,
            bundle: false,
            price: null,
            applePayForm: {
                terms: '',
            },
            payPalForm: {
                terms: '',
            },
            showPayPalCheckout: false,
            showApplePayCheckout: false,
            // Upsell Payment Modal
            upsellLineOne: '',
            upsellLineTwo: '',
            // Processing payment modal
            paymentStatus: 'processing',
            // Recalls
            showRecallDescription: {0:false, 1:false, 2:false, 3:false, 4:false, 5:false, 6:false, 7:false, 8:false, 9:false,
                                    10:false, 11:false, 12:false, 13:false, 14:false, 15:false, 16:false, 17:false, 18:false, 19:false},
            showMotAdvisory: {0:false, 1:false, 2:false, 3:false, 4:false, 5:false, 6:false, 7:false, 8:false, 9:false,
                                 10:false, 11:false, 12:false, 13:false, 14:false, 15:false, 16:false, 17:false, 18:false, 19:false},
            showMotMinorAdvisory: {0:false, 1:false, 2:false, 3:false, 4:false, 5:false, 6:false, 7:false, 8:false, 9:false,
                                10:false, 11:false, 12:false, 13:false, 14:false, 15:false, 16:false, 17:false, 18:false, 19:false},
            showMotRefusalReason: {0:false, 1:false, 2:false, 3:false, 4:false, 5:false, 6:false, 7:false, 8:false, 9:false,
                                  10:false, 11:false, 12:false, 13:false, 14:false, 15:false, 16:false, 17:false, 18:false, 19:false},
            // the bundle variable referenced in the public.page.partial.vrm-input-modal include at the end show.blade.php
            // needs the variable initialised, otherwise this is redundant. There's proabably a more efficient way to do this.
            bundle: null,
            reportCurrentMileageCount: this.currentMileageCount,
            visibleValuation: this.valuation,
            visibleDepreciationData: null,
            // Valuation
            priceType: 'Trade Values',
            priceLevel: 'Average',
            annualDepreciation: '',
        }
    },
    props: [
        'verifyVinUrl',
        'uploadImageUrl',
        'deleteImageUrl',
        'verifyFinanceUrl',
        'writeOffInvestigationUrl',
        'stolenInvestigationUrl',
        'atRiskInvestigationUrl',
        'conditionAlertInvestigationUrl',
        'mileageInvestigationUrl',
        'addMileageReadingUrl',
        'buyUpsellUrl',
        'refreshMotDataUrl',
        'retrieveValuationDataUrl',
        'reportHashid',
        'vin',
        'vinIsVerified',
        'imageUrl',
        'hasCustomImage',
        'agreements',
        'writeoffs',
        'stolenRecords',
        'atRiskRecords',
        'mileage',
        'mileageChartDataKm',
        'mileageChartDataMiles',
        'mileageDiscrepancy',
        'motHistory',
        'motData',
        'cards',
        'productDetails',
        'currentMileageCount',
        'valuation',
        'depreciationData',
        'scrapped',
        'conditionAlerts',
        'taxiRecords',
        'valuation',
        'majorTaxiFlags', 
        'minorTaxiFlags'
    ],

    computed: {
        imageStyle: function () {
            return "background-image: url('" + this.reportImageUrl + "');"
        },

    },

    mounted() {
        if (this.visibleValuation !== null) {
            if (this.visibleValuation.error == 'Valuation Not Available') {
                this.retrieveValuationDataError = 'unable-to-value';
            } else {
                this.retrieveValuationDataError = 'no-new-data';
            }
            this.valuationChart();
        }

        // PayPal
        let self = this;

        const paypalButtonsComponent = paypal.Buttons({
            // Sets up the transaction when a payment button is clicked
            createOrder: function(data, actions) {
                return actions.order.create({
                    purchase_units: [{
                        amount: {
                            value: self.selectedPrice
                        }
                    }],
                    application_context: {
                        shipping_preference: "NO_SHIPPING"
                    }
                });
            },

            // Finalize the transaction after payer approval
            onApprove: function(data, actions) {
                const captureOrderHandler = (details) => {
                    let postData = {
                        method: 'payPal',
                        bundle: self.bundle,
                        product: self.product,
                        pay_pal_charge_id: details.id,
                    }

                    axios
                        .post(self.buyUpsellUrl, postData)
                        .then((response) => {
                            location.reload();
                        })
                        .catch((error) => {
                            self.handleError(error.response.data);
                        });
                };

                return actions.order.capture().then(captureOrderHandler);
            },

            // handle unrecoverable errors
            onError: (err) => {
                console.error('An error prevented the buyer from checking out with PayPal');
                self.handleError(err.response.data);
            }
        });

        paypalButtonsComponent
            .render("#paypal-button-container")
            .catch((err) => {
                console.error('PayPal Buttons failed to render');
            });
    },

    watch: {
        payPalForm: {
            handler() {
                this.togglePayPalCheckout();
            },
            deep: true,
        },
        applePayForm: {
            handler() {
                this.toggleApplePayCheckout();
            },
            deep: true,
        },
    },

    methods: {
        togglePayPalCheckout() {
            this.$validator.validateAll('payPalForm').then(result => {
                this.showPayPalCheckout = result;
            });
        },

        toggleApplePayCheckout() {
            this.$validator.validateAll('applePayForm').then(result => {
                this.showApplePayCheckout = result;
            });
        },

        collapseMultiple (group) {
            $('.multi-collapse-' + group).collapse('hide');
        },

        startVinVerification() {
            this.showVerifyVinForm = true,
            this.reportVin = ''

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $("#link-identity").offset().top
            }, 1000);
        },

        submitVerifyVin() {
            let postData = {
                report_hashid: this.reportHashid,
                vin: this.reportVin,
            }

            this.$validator.validateAll('general-details-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.saveVerifyVin(postData);
                }
            });
        },

        saveVerifyVin(postData) {
            axios
            .post(this.verifyVinUrl, postData)
            .then(response => {
                // show the success message
                this.showIdentityVerificationMessage = true;
                this.identityVerificationMessage = 'The VIN you entered matches the official VIN on file';
                this.identityVerificationMessageClass = 'bg-status-green w-100 d-flex';

                this.reportVin = response.data.vin;
                this.reportVinIsVerified = true;
                // Hide the verify vin form
                this.showVerifyVinForm = false;
                this.showVerifyVinButton = false;
            })
            .catch(error => {
                this.showIdentityVerificationMessage = true;
                this.identityVerificationMessage = 'The VIN you entered does not match the official VIN on file';
                this.identityVerificationMessageClass = 'bg-status-red w-100 d-flex';
                this.reportVin = '#############';
                this.showVerifyVinForm = false;
            });
        },

        submitReportImage() {
            let postData = new FormData();
            postData.append('report_hashid', this.reportHashid);
            postData.append('report_image', this.reportImage);

            this.$validator.validateAll('update-image-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.saveReportImage(postData);
                }
            });
        },

        saveReportImage(postData) {
            axios
                .post(
                    this.uploadImageUrl,
                    postData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                )
                .then(response => {
                    // show the success message
                    this.$store.dispatch('setMessage', {
                        text: 'Your image has been uploaded',
                        type: 'success'
                    });

                    $('#update-image-modal').modal('hide');
                    this.reportImageUrl = response.data.image;
                    this.customImageSet = true;
                })
                .catch(error => {
                    this.$store.dispatch('setMessage', {
                        text: 'Your image has not been updated. It must be a jpeg, png or gif',
                        type: 'danger'
                    })
                });
        },

        handleFileUpload() {
            this.reportImage = this.$refs.file.files[0];
        },

        removeReportImage() {
            let postData = {
                report_hashid: this.reportHashid,
            }
            this.deleteReportImage(postData);
        },

        deleteReportImage(postData) {
            axios
            .post(this.deleteImageUrl, postData)
            .then(response => {
                // show the success message
                this.$store.dispatch('setMessage', {
                    text: 'Your image has been deleted',
                    type: 'success'
                });

                this.reportImageUrl = response.data.image;
                this.customImageSet = false;
            })
            .catch(error => {
                this.$store.dispatch('setMessage', {
                    text: 'Your image has not been deleted.',
                    type: 'danger'
                })
            });
        },

        startFinanceVerification(md5, number, index) {
            // Init the financeVerification form with the new details
            this.financeVerification = {
                md5: md5,
                number: number,
                content: '',
                files: [],
            };
            this.showFinanceVerificationForm = true;
            this.agreementIndex = index;

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $("#link-finance").offset().top
            }, 1000);
        },

        handleVerificationFiles() {
            this.financeVerification.files = this.$refs.verification_files.files;
        },

        submitVerifyFinance() {
            this.$validator.validateAll('verify-finance-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.saveVerifyFinance();
                }
            });
        },

        saveVerifyFinance() {
            const files = [...this.financeVerification.files];

            let postData = new FormData();
            postData.append('md5', this.financeVerification.md5);
            postData.append('number', this.financeVerification.number);
            postData.append('content', this.financeVerification.content);

            // Loop through all of the files and append them
            for (var i = 0; i < files.length; i++) {
                postData.append('files['+i+']', files[i])
            }

            axios
                .post(
                    this.verifyFinanceUrl,
                    postData,
                    {headers: {'Content-Type': 'multipart/form-data'}}
                )
                .then(response => {
                    // show the success message
                    this.showFinanceVerificationMessage = true;
                    this.financeVerificationMessage = "Your Finance Verification has been submitted to the service team. We'll be in touch soon";
                    this.financeVerificationMessageClass = 'bg-status-green w-100 d-flex';

                    // Hide the form
                    this.showFinanceVerificationForm = false;

                    // Update the finance agreements
                    this.visibleAgreements = response.data.finances;
                })
                .catch(error => {
                    this.showFinanceVerificationMessage = true;
                    this.financeVerificationMessage = "There was an error";
                    this.financeVerificationMessageClass = 'bg-status-red w-100 d-flex';
                });
        },

        /**
         * Write off investigations
         *
         */
        startWriteOffInvestigation(md5, number, index) {
            // Init the stolenInvestigations form with the new details
            this.writeOffInvestigation = {
                md5: md5,
                number: number,
                content : ''
            };
        },

        saveWriteOffInvestigation() {
            axios
                .post(this.writeOffInvestigationUrl, this.writeOffInvestigation)
                .then(response => {
                    // show the success message
                    this.showWriteOffInvestigationMessage = true;
                    this.writeOffInvestigationMessage = "Your Write Off Investigation has been submitted to the service team. We'll be in touch soon";
                    this.writeOffInvestigationMessageClass = 'bg-status-green w-100 d-flex';

                    // Update the write offs
                    this.visibleWriteOffs = response.data.writeOff;
                })
                .catch(error => {
                    this.writeOffInvestigationMessage = "There was an error";
                    this.writeOffInvestigationMessageClass = 'bg-status-red w-100 d-flex';
                });

            // Hide the modal
            $('#writeoff-investigation-modal').modal('hide');
            //reset data
            this.writeOffInvestigation = {
                md5: null,
                number: null,
                content : null
            };

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $("#link-write_off").offset().top
            }, 1000);
        },

        /**
         * Stolen investigations
         *
         */
        startStolenInvestigation(md5, number, index) {
            // Init the stolenInvestigations form with the new details
            this.stolenInvestigation = {
                md5: md5,
                number: number,
                content: ''
            };
            this.stolenIndex = index;
        },

        saveStolenInvestigation() {
            axios
                .post(this.stolenInvestigationUrl, this.stolenInvestigation)
                .then(response => {
                    // show the success message
                    this.showStolenInvestigationMessage = true;
                    this.stolenInvestigationMessage = "Your Stolen Investigation has been submitted to the service team. We'll be in touch soon";
                    this.stolenInvestigationMessageClass = 'bg-status-green w-100 d-flex';

                    // Update the stolen records
                    this.visibleStolenRecords = response.data.stolenRecords;
                })
                .catch(error => {
                    this.stolenInvestigationMessage = "There was an error";
                    this.stolenInvestigationMessageClass = 'bg-status-red w-100 d-flex';
                });

            // Hide the modal
            $('#stolen-investigation-modal').modal('hide');

            //reset data
            this.stolenInvestigation = {
                md5: null,
                number: null,
                content: null
            };

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $("#link-stolen").offset().top
            }, 1000);
        },

        /**
         * At Risk investigations
         *
         */
        startAtRiskInvestigation(md5, number, index) {
            // Init the stolenInvestigations form with the new details
            this.atRiskInvestigation = {
                md5: md5,
                number: number,
                content: ''
            };
            this.atRiskIndex = index;
        },

        saveAtRiskInvestigation() {
            axios
                .post(this.atRiskInvestigationUrl, this.atRiskInvestigation)
                .then(response => {
                    // show the success message
                    this.showAtRiskInvestigationMessage = true;
                    this.atRiskInvestigationMessage = "Your At Risk Investigation has been submitted to the service team. We'll be in touch soon";
                    this.atRiskInvestigationMessageClass = 'bg-status-green w-100 d-flex';

                    // Update the atRisk records
                    this.visibleAtRiskRecords = response.data.atRiskRecords;
                })
                .catch(error => {
                    this.atRiskInvestigationMessage = "There was an error";
                    this.atRiskInvestigationMessageClass = 'bg-status-red w-100 d-flex';
                });

            // Hide the modal
            $('#at-risk-investigation-modal').modal('hide');

            //reset data
            this.atRiskInvestigation = {
                md5: null,
                number: null,
                content: null
            };

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $("#link-at_risk").offset().top
            }, 1000);
        },

        /**
         * Mileage Readings
         *
         */
        submitMileageReading() {
            this.$validator.validateAll('mileage-reading-form').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    this.saveMileageReading();
                }
            });
        },

        /**
         * Condition Alert investigations
         *
         */
        startConditionAlertInvestigation(md5, number, index) {
            // Init the conditionAlertInvestigations form with the new details
            this.conditionAlertInvestigation = {
                md5: md5,
                number: number,
                content: ''
            };
            this.conditionAlertIndex = index;
        },

        saveConditionAlertInvestigation() {
            axios
                .post(this.conditionAlertInvestigationUrl, this.conditionAlertInvestigation)
                .then(response => {
                    // show the success message
                    this.showConditionAlertInvestigationMessage = true;
                    this.conditionAlertInvestigationMessage = "Your Condition Alert Investigation has been submitted to the service team. We'll be in touch soon";
                    this.conditionAlertInvestigationMessageClass = 'bg-status-green w-100 d-flex';

                    // Update the condition alert records
                    this.visibleConditionAlertRecords = response.data.conditionAlertRecords;
                })
                .catch(error => {
                    this.conditionAlertInvestigationMessage = "There was an error";
                    this.conditionAlertInvestigationMessageClass = 'bg-status-red w-100 d-flex';
                });

            // Hide the modal
            $('#condition-alert-investigation-modal').modal('hide');

            //reset data
            this.conditionAlertInvestigation = {
                md5: null,
                number: null,
                content: null
            };

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $("#link-condition_alert").offset().top
            }, 1000);
        },


        saveMileageReading() {
            var postData =  {reading: this.odometerReading, unit: this.odometerUnits}

            // Hide the modal
            $('#mileage-reading-modal').modal('hide');
            $('#add-mileage-modal').modal('show');

            axios
                .post(this.addMileageReadingUrl, postData)
                .then(response => {
                    if (response.data.success == true) {
                        // show the success message
                        this.showMileageInvestigationMessage = true;
                        this.mileageInvestigationMessage = "Your mileage reading has been added.";
                        this.mileageInvestigationMessageClass = 'bg-status-green w-100 d-flex';

                        // Update the mileage records
                        this.visibleMileage = response.data.mileage;
                        this.hasMileageDiscrepancy = response.data.hasMileageDiscrepancy;
                        // Update valuation data
                        this.visibleValuation = response.data.valuation;

                        this.reportCurrentMileageCount++;

                        var date = this.todaysDate();

                        if (response.data.depreciationChartData) {
                            this.visibleDepreciationData = response.data.depreciationChartData;
                        }

                        if(this.odometerUnits == 'ml') {
                            this.visibleMileageChartDataMiles[date] = this.odometerReading;
                            this.visibleMileageChartDataKm[date] = Math.round(this.odometerReading * 1.609);
                        } else {
                            this.visibleMileageChartDataKm[date] = this.odometerReading;
                            this.visibleMileageChartDataMiles[date] = Math.round(this.odometerReading / 1.609);
                        }
                    } else {
                        this.showMileageInvestigationMessage = true;
                        this.mileageInvestigationMessage = response.data.message;
                        this.mileageInvestigationMessageClass = 'bg-status-red w-100 d-flex';
                    }
                    // Delay needed or modal won't close in some cases.
                    setTimeout(function(){
                        $('#add-mileage-modal').modal('hide');
                    }, 2000);
                })
                .catch(error => {
                    this.showMileageInvestigationMessage = true;
                    this.mileageInvestigationMessage = "There was an error adding your mileage reading.";
                    this.mileageInvestigationMessageClass = 'bg-status-red w-100 d-flex';
                    $('#add-mileage-modal').modal('hide');
                });
        },

        /**
         * Mileage investigations
         *
         */
        saveMileageInvestigation() {
            axios
                .post(this.mileageInvestigationUrl, this.mileageInvestigation)
                .then(response => {
                    // show the success message
                    this.showMileageInvestigationMessage = true;
                    this.mileageInvestigationMessage = "Your Mileage Investigation has been submitted to the service team. We'll be in touch soon";
                    this.mileageInvestigationMessageClass = 'bg-status-green w-100 d-flex';

                    // Update the mileage records
                    this.visibleMileage = response.data.mileage;
                })
                .catch(error => {
                    this.mileageInvestigationMessage = "There was an error";
                    this.mileageInvestigationMessageClass = 'bg-status-red w-100 d-flex';
                });

            // Hide the modal
            $('#mileage-investigation-modal').modal('hide');

            // Scroll to top of section
            $('html, body').animate({
               scrollTop: $("#link-mileage").offset().top
            }, 1000);
        },

        /**
         * Payments
         *
         */
        submitStripePayment() {
            let self = this;

            self.disableOnSubmit = true;

            this.$validator.validateAll('stripeForm').then(result => {
                // If the form is valid, proceed to submit it using the event
                if (result) {
                    $('#upsell-payment-modal').modal('hide');
                    $('#processing-modal').modal({backdrop: 'static', keyboard: false});
                    this.saveUpsellPayment();
                } else {
                    self.disableOnSubmit = false;
                }
            });
        },

        saveUpsellPayment() {
            this.stripePaymentRequestCount++;

            // Only send call buy-report once. Fix to double click/double post issue.
            if (this.stripePaymentRequestCount < 2) {
                axios
                    .post(this.buyUpsellUrl, this.stripeForm)
                    .then(response => {
                        $('#processing-modal').modal('hide');
                        // reload the page
                        location.reload();
                    })
                    .catch(error => {
                        this.stripePaymentRequestCount = 0;
                        this.handleError(error.response.data);
                    });
            }
        },

        applePayCompleted: function(ev) {
            $('#upsell-payment-modal').modal('hide');
            $('#processing-modal').modal({backdrop: 'static', keyboard: false});

            let postData = {
                method: 'applePay',
                bundle: this.stripeForm.bundle,
                stripe_token: ev.token.id,
            }

            axios
                .post(this.buyUpsellUrl, postData)
                .then(response => {
                    location.reload();
                    // Report to the browser that the payment was successful, prompting
                    // it to close the browser payment interface.
                    ev.complete('success');
                })
                .catch(error => {
                    this.handleError(error.response.data);
                    // Report to the browser that the payment failed, prompting it to
                    // re-show the payment interface, or show an error message and close
                    // the payment interface.
                    ev.complete('fail');
                });
        },

        refreshMotData: function(ev) {
            // ajax call to new endpoint
            var postData =  {};

            // Show the modal
            $('#refresh-mot-data-modal').modal('show');

            axios
                .post(this.refreshMotDataUrl, postData)
                .then(response => {
                    if (response.data.success == true) {
                        // show the success message
                        this.showRefreshMotDataMessage = true;
                        this.refreshMotDataMessage = "Your MOT data has been refreshed.";
                        this.refreshMotDataMessageClass = 'bg-status-green w-100 d-flex';
                        // Update the MOT data
                        this.visibleMotData = response.data.motData;
                        this.visibleMotHistory = response.data.motHistory;
                        // Update the mileage records
                        this.visibleMileage = response.data.mileage;
                    } else {
                        this.showRefreshMotDataMessage = true;
                        this.refreshMotDataMessage = response.data.message;
                        this.refreshMotDataMessageClass = 'bg-status-red w-100 d-flex';
                    }
                    // Delay needed or modal won't close in some cases.
                    setTimeout(function(){
                        $('#refresh-mot-data-modal').modal('hide');
                    }, 2000);
                })
                .catch(error => {
                    this.showRefreshMotDataMessage = true;
                    this.refreshMotDataMessage = "There was an error refreshing MOT data.";
                    this.refreshMotDataMessageClass = 'bg-status-red w-100 d-flex';
                    $('#refresh-mot-data-modal').modal('hide');
                });

        },

        retrieveValuation() {
            // ajax call to new endpoint
            var postData =  {};

            // Show the modal
            $('#retrieve-valuation-data-modal').modal('show');

            axios
                .post(this.retrieveValuationDataUrl, postData)
                .then(response => {
                    if (response.data.success == true) {
                        // show the success message
                        this.showRetrieveValuationDataMessage = true;
                        this.retrieveValuationDataMessage = "Your valuation data has been retrieved.";
                        this.retrieveValuationDataMessageClass = 'bg-status-green w-100 d-flex';
                        location.reload();

                    } else {
                        this.showRetrieveValuationDataMessage = true;
                        this.retrieveValuationDataMessage = response.data.message;
                        this.retrieveValuationDataMessageClass = 'bg-status-red w-100 d-flex';
                        this.retrieveValuationDataError = response.data.error;
                    }
                    // Delay needed or modal won't close in some cases.
                    setTimeout(function(){
                        $('#retrieve-valuation-data-modal').modal('hide');
                    }, 2000);
                })
                .catch(error => {
                    this.showRetrieveValuationDataMessage = true;
                    this.retrieveValuationDataMessage = "There was an error refreshing valuation data.";
                    this.retrieveValuationDataMessageClass = 'bg-status-red w-100 d-flex';
                    $('#retrieve-valuation-data-modal').modal('hide');
                });
        },

        setProduct(product, price, isBundle) {
            this.product = product;
            this.bundle = isBundle;
            this.price = price;
            this.selectedPrice = price;
            this.upsellLineOne = this.product + ' Check - '+(this.bundle ? 'Bundle':'Single');
            this.upsellLineTwo = ' for '+(this.bundle ?  'three checks':'one check');
        },


        validationClass(hasErrors) {
            return this.$parent.validationClass(hasErrors);
        },

        showRecallInfo(index) {
            this.showRecallDescription[index] = true;
        },

        hideRecallInfo(index) {
            this.showRecallDescription[index] = false;
        },

        showMotRefusalReasonInfo(index) {
            this.showMotRefusalReason[index] = true;
        },

        hideMotRefusalReasonInfo(index) {
            this.showMotRefusalReason[index] = false;
        },

        showMotAdvisoryInfo(index) {
            this.showMotAdvisory[index] = true;
        },

        hideMotAdvisoryInfo(index) {
            this.showMotAdvisory[index] = false;
        },

        showMotMinorAdvisoryInfo(index) {
            this.showMotMinorAdvisory[index] = true;
        },

        hideMotMinorAdvisoryInfo(index) {
            this.showMotMinorAdvisory[index] = false;
        },

        todaysDate() {
            var today = new Date();
            var month = today.getMonth()+1 < 10 ? "0" + (today.getMonth()+1) : today.getMonth()+1;
            var date = today.getFullYear() + '-' + (month) + '-' + today.getDate();
            return date;
        },

        handleError(response) {
            let errorCode, message;

            if (typeof response.error == 'object') {
                response = response.error;
            }

            if ('stripe_code' in response) {
                this.errorCode = response.stripe_code;
                if (this.errorCode == '0000') {
                    this.paymentStatus = 'error-general';
                    return;
                };
                this.errorMessage = response.message;
                this.paymentStatus = 'error-stripe';
                return;
            };

            message = response.message;

            switch (message) {
                case 'Validation failed':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00422';
                    break;
                case 'Server Error':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00501';
                    break;
                case 'There has been a server error trying to complete your request. If this error persists please contact support to report the issue.':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00500';
                    break;
                case 'response_exception':
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00588';
                    break;
                default:
                    this.paymentStatus = 'error-general';
                    this.errorCode = '00599';
            }
        },

        closeModal () {
            this.disableOnSubmit = false;
            $('#processing-modal').modal('hide');
            $('#upsell-payment-modal').modal('show');
            this.paymentStatus = 'processing';
        },

        valuationChart() {
            if (this.priceType == 'Trade Values' || this.priceType == 'Consumer Values' ) {
                this.visibleDepreciationData = this.visibleValuation.chartData[this.priceType][this.priceLevel].chartDataPoints;
                this.annualDepreciation = (this.visibleValuation.chartData[this.priceType][this.priceLevel]['Avg. Annual Depreciation'] * 100).toFixed(2);
            } else {
                this.visibleDepreciationData = this.visibleValuation.chartData[this.priceType].chartDataPoints;
                this.annualDepreciation = (this.visibleValuation.chartData[this.priceType]['Avg. Annual Depreciation'] * 100).toFixed(2);
            }
        },

        formatDate(date) {
            var month = '';
            switch (date.substring(5, 7)) {
                case '01':
                    month = 'Jan';
                    break;
                case '02':
                    month = 'Feb';
                    break;
                case '03':
                    month = 'Mar';
                    break;
                case '04':
                    month = 'Apr';
                    break;
                case '05':
                    month = 'May';
                    break;
                case '06':
                    month = 'Jun';
                    break;
                case '07':
                    month = 'Jul';
                    break;
                case '08':
                    month = 'Aug';
                    break;
                case '09':
                    month = 'Sep';
                    break;
                case '10':
                    month = 'Oct';
                    break;
                case '11':
                    month = 'Nov';
                    break;
                case '12':
                    month = 'Dec';
                    break;
            }
            return month + ' ' + date.substring(0, 4);
        },

        formatDateYmd(date) {
            return date.substring(8, 10) + '/' + date.substring(5, 7) + '/' + date.substring(0, 4);
        },

        goToReportLink(link) {
            document.location.hash = link;
            $("#report_title").click();
        },

        getRecordAlertClass(type) {
            if (this.majorTaxiFlags && this.majorTaxiFlags.includes(type)) {
                return 'bg-status-red';
            } else if (this.minorTaxiFlags && this.minorTaxiFlags.includes(type)) {
                return 'bg-status-orange';
            }
            return '';
        }
    },
    
    components: {
        StripePay,
    }
}
</script>
